import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";


import Form from 'react-bootstrap/Form';

import Skeleton from 'react-loading-skeleton'

const FormSwitch = (props) => {    
    const [value, setValue] = useState(false);

    useEffect(() => {
        var value = props.object?.[props.id];
        var initial = value || false;

        if (value == null && props?.valueIfNull) { initial = props.valueIfNull }

        updateValue(initial);
        
        //setTextArea(test);
    }, [props.object]);

    /*useEffect(() => {
        var test = props.defaultValue || false;
        updateValue(test);    
    }, [props.defaultValue]);*/

    const updateValue = (val) => {        
        setValue(val);
        if (props.observe) {props.observe(val); }
    }

    return (

        <Form.Group controlId={props.id}>
            {props.title ? <>{props.isLoading ? <Skeleton /> : <Form.Label>{props.title}</Form.Label>}</> : <span />}
            {props.isLoading ? <Skeleton height={30} /> : <Form.Check
                name={props.id}
                type={props.type ?? "switch"}
                required={props.required}
                disabled={props.disabled}
                label={props.label}
                checked={value} onChange={(e) => { if (props?.onChange) { props.onChange(e.target.checked) } updateValue(e.target.checked) }} />
            }
        </Form.Group>

    );
};

export default observer(FormSwitch);
